/**
 * PortalRequest
 *
 * This object handles making ajax calls to the API. The idea is that it handles the nitty gritty
 * details, so requests can be made as simply as possible.
 */

// the constructor for this object
function PortalRequest() { }

// the object
PortalRequest.prototype = {
    constructor: PortalRequest,

    // the token object gets stored here
    TokenObject: null,

    // determines if the token found in the response should be stored for use in future requests
    storeToken: false,

    // if the returned data is binary
    isBinary: false,

    // the element selector to display the error messages
    errorElement: false,

    // similar to above, but for success messages
    successElement: false,

    // the page number to use in the pagination request
    pageNumber: false,

    // make an ajax request the provided route
    makeRequest: function(
        route,
        parameters,
        successCallback,
        errorCallback
    ) {
        // set the default parameter values
        parameters = (typeof parameters == 'object') ?  parameters : {};
        successCallback = (typeof successCallback !== 'undefined') ?  successCallback : null;
        errorCallback = (typeof errorCallback !== 'undefined') ?  errorCallback : null;

        // get the data about this route, and throw an error if none found
        var routeData = this._getRouteData(route);
        if (typeof routeData == 'undefined') {
            throw new Error('The provided route is not valid');
        }

        // return an error if auth is expected, but a token is not set
        if (typeof routeData.auth !== 'undefined' && routeData.auth && !PortalMain.PortalToken.getToken()) {
            throw new Error('You cannot make this request without first setting a token.');
        }

        // hide the error element
        if (this.errorElement) {
            this._hideErrorElement();
        }

        // hide the success element
        if (this.successElement) {
            this._hideSuccessElement();
        }

        // build the url
        var url = this._parseUrl(routeData, parameters);

        // apply the pagination to the url
        if (this.pageNumber !== false) {
            url = this._applyPageNumber(url);
        }

        // clean up the parameters
        parameters = this._parseMethodParameters(routeData, parameters);

        // get the headers to be used for this request
        var headers = this._getRequestHeaders(routeData);

        // fill in the base ajax settings
        var ajaxSettings = {
            method: routeData.method,
            data: parameters,
            context: this,
            headers: headers,
            success: function(data) {
                this._successMethod(data, successCallback);
            },
            error: function(data) {
                this._errorMethod(data.responseJSON, errorCallback);
            },
        };

        // include the binary option
        if (this.isBinary) {
            ajaxSettings.dataType = 'binary';
        }

        // make the ajax request
        $.ajax(
            url,
            ajaxSettings
        );
    },

    makeJsonDataRequest: function(
      route,
      parameters,
      successCallback,
      errorCallback
  ) {
      // set the default parameter values
      parameters = (typeof parameters == 'object') ?  parameters : {};
      successCallback = (typeof successCallback !== 'undefined') ?  successCallback : null;
      errorCallback = (typeof errorCallback !== 'undefined') ?  errorCallback : null;

      // get the data about this route, and throw an error if none found
      var routeData = this._getRouteData(route);
      if (typeof routeData == 'undefined') {
          throw new Error('The provided route is not valid');
      }

      // return an error if auth is expected, but a token is not set
      if (typeof routeData.auth !== 'undefined' && routeData.auth && !PortalMain.PortalToken.getToken()) {
          throw new Error('You cannot make this request without first setting a token.');
      }

      // hide the error element
      if (this.errorElement) {
          this._hideErrorElement();
      }

      // hide the success element
      if (this.successElement) {
          this._hideSuccessElement();
      }

      // build the url
      var url = this._parseUrl(routeData, parameters);

      // apply the pagination to the url
      if (this.pageNumber !== false) {
          url = this._applyPageNumber(url);
      }

      // clean up the parameters
      parameters = this._parseMethodParameters(routeData, parameters);

      // get the headers to be used for this request
      var headers = this._getRequestHeaders(routeData);

      // fill in the base ajax settings
      var ajaxSettings = {
          method: routeData.method,
          data: JSON.stringify(parameters),
          context: this,
          headers: headers,
          processData: false,
          contentType: 'application/json',
          success: function(result, status, xhr) {
              if (result.success === false) {
                  this._errorMethod(result, errorCallback);
              }
              this._successMethod(result, successCallback);
          },
          error: function(xhr, status, error) {
              this._errorMethod(xhr.responseJSON, errorCallback);
          },
      };

      // include the binary option
      if (this.isBinary) {
          ajaxSettings.dataType = 'binary';
      }

      // make the ajax request
      $.ajax(
          url,
          ajaxSettings
      );
  },


  makeFileDataRequest: function(
    route,
    parameters,
    successCallback,
    errorCallback,
    contentType = 'application/json',
    encType = null
) {
    // set the default parameter values
    parameters = (typeof parameters == 'object') ?  parameters : {};
    successCallback = (typeof successCallback !== 'undefined') ?  successCallback : null;
    errorCallback = (typeof errorCallback !== 'undefined') ?  errorCallback : null;

    // get the data about this route, and throw an error if none found
    var routeData = this._getRouteData(route);
    if (typeof routeData == 'undefined') {
        throw new Error('The provided route is not valid');
    }

    // return an error if auth is expected, but a token is not set
    if (typeof routeData.auth !== 'undefined' && routeData.auth && !PortalMain.PortalToken.getToken()) {
        throw new Error('You cannot make this request without first setting a token.');
    }

    // hide the error element
    if (this.errorElement) {
        this._hideErrorElement();
    }

    // hide the success element
    if (this.successElement) {
        this._hideSuccessElement();
    }

    // build the url
    var url = this._parseUrl(routeData, parameters);

    // apply the pagination to the url
    if (this.pageNumber !== false) {
        url = this._applyPageNumber(url);
    }

    // clean up the parameters
    parameters = this._parseMethodParameters(routeData, parameters);

    // get the headers to be used for this request
    var headers = this._getRequestHeaders(routeData);

    var formData = new FormData();
    if (parameters.files) {
      parameters.files.forEach(function (file) {
        formData.append('fileUploads[]', file);
      });
    }

    Object.keys(parameters).forEach(function (key) {
      formData.append(key, parameters[key]);
    });

    // fill in the base ajax settings
    var ajaxSettings = {
        method: routeData.method,
        data: formData,
        context: this,
        headers: headers,
        processData: false,
        contentType,
        success: function(data) {
            this._successMethod(data, successCallback);
        },
        error: function(data) {
            this._errorMethod(data.responseJSON, errorCallback);
        },
    };

    if (encType) {
      ajaxSettings.enctype = encType;
    }

    // include the binary option
    if (this.isBinary) {
        ajaxSettings.dataType = 'binary';
    }

    // make the ajax request
    $.ajax(
        url,
        ajaxSettings
    );
  },

    // get the data from the route json that matches the provide route name
    _getRouteData: function(routeName)
    {
        var routeData = PortalConfig.routes.filter(function(route) {
            return route.route == routeName;
        });

        return routeData[0];
    },

    // splice the parameters into the url
    _parseUrl: function(routeData, parameters)
    {
        // get the base url of the api and route
        var url = PortalConfig.apiUrl;
        url += routeData.uri;

        // find and replace the parameters in the url. these are denoted with { and }
        for(var param in parameters) {
            var value = parameters[param];
            var param = '{' + param + '}';
            url = url.replace(param, value);
        }

        // remove unfilled optional parameters. these would be at the end of the route like /{param}[/{optional}]
        url = url.replace(/\[\/\{([^}]+)}\]/, '');

        // remove the optional parameter brackets left over from those that were filled in
        url = url.replace('[', '');
        url = url.replace(']', '');

        // confirm that all route parameters have been filled in
        if (url.indexOf('{') !== -1) {
            throw new Error('The route (' + routeData.route + ') is missing a route parameter');
        }

        return url;
    },

    // apply the page number to the request url for pagination
    _applyPageNumber: function(url)
    {
        url += '?page=' + this.pageNumber;

        return url;
    },

    // remove parameters that don't match the ones set in the route
    _parseMethodParameters: function(routeData, parameters)
    {
        var methodParameters = {};

        // if the route doesn't have any method parameters, return the empty object
        if (typeof routeData.methodParameters == 'undefined') {
            return methodParameters;
        }

        // loop through the provided parameters and add only applicable ones to the returning object
        for(var param in parameters) {
            if (routeData.methodParameters.indexOf(param) !== -1) {
                var value = parameters[param];
                methodParameters[param] = value;
            }
        }

        // account for the array based parameters and include them if they meet the rules
        for(var param in parameters) {

            // if the value of the parameters is an array (or object as javascript does), check those
            var values = parameters[param];
            if (typeof values == 'object') {

                // store include sets in this variable to be included in the returned parameters
                var finalSet = [];
                for (var i in values) {

                    // setup the array set, and the set that should be included
                    var arraySet = values[i];
                    var includeSet = {};
                    for (var subParam in arraySet) {

                        // create the expected methodParam and check if it exists
                        var methodParam = param + '.*.' + subParam;
                        if (routeData.methodParameters.indexOf(methodParam) !== -1) {
                            includeSet[subParam] = arraySet[subParam];
                        }
                    }

                    // add the include set to the final set if values were added to it
                    if (Object.keys(includeSet).length > 0) {
                        finalSet.push(includeSet);
                    }
                }
                // there are parameters to be included
                if (finalSet.length > 0) {
                    methodParameters[param] = finalSet;
                }
            }
        }

        return methodParameters;
    },

    // get the headers to be used for the ajax request
    _getRequestHeaders: function(routeData)
    {
        var headers = {
            'X-Requested-With': 'XMLHttpRequest'
        };

        // if the route requires authorization, automatically include the stored token
        if (typeof routeData.auth !== 'undefined' && routeData.auth === true) {
            var portalToken = PortalMain.PortalToken.getToken();
            headers['Authorization'] = 'Bearer ' + portalToken;
        }

        return headers;
    },

    // handles the universal actions associated with a successful request, and runs the custom callback
    _successMethod: function(response, successCallback)
    {
        // if storeToken is set, a token value is expected in the response. Add it to the portal token object
        if (this.storeToken) {
            var token = response.data.token;
            PortalMain.PortalToken.setToken(token);
        }

        //show success message (if success element is set)
        if(this.successElement) {
            this._showSuccessElement(response);
        }

        // run the application defined callback
        if (typeof successCallback == 'function') {

            // if this is a binary response, no codes, or messages are returned, just straight data
            if (this.isBinary) {
                response.data = response;
            }

            successCallback(
                response.data,
                response.code,
                response.message
            );
        }
    },

    // handles the universal actions associated with an errored request, and runs the custom callback
    _errorMethod: function(response, errorCallback)
    {
        // binary data types don't return these, so set to null
        var responseData = typeof response === 'undefined' ? null : response.data;
        var responseCode = typeof response === 'undefined' ? null : response.code;
        var responseMessage = typeof response === 'undefined' ? null : response.message;

        // if there is a particular response code, redirect the user back to the login page
        this._errorRedirect(responseCode);

        // if there is a throttle error, show it
        this._showThrottleError(responseCode);

        // redirect the user if they have not accepted a legal agreement
        this._redirectLegalError(responseCode);

        // redirect the us signal user if they don't have two-factor enabled
        this._redirectTwoFactor(responseCode, responseMessage);

        // if a error element selector is set, populate it with the errors
        if (this.errorElement) {
            this._showErrorElement(response);
        }

        // run the application defined callback
        if (typeof errorCallback == 'function') {
            errorCallback(
                responseData,
                responseCode,
                responseMessage
            );
        }
    },

    // redirect the user to the login page in the event of particular error codes
    _errorRedirect: function(code)
    {
        var responseCodes = PortalConfig.redirectResponseCodes;

        if (responseCodes.indexOf(code) !== -1) {
            // clear the token
            PortalMain.PortalToken.clearToken();

            // redirect
            var redirectUrl = PortalConfig.loginUrl;
            window.location.href = redirectUrl;
        }

    },

    // show the throttle error message
    _showThrottleError: function(responseCode)
    {
        if (responseCode == 'TOO_MANY_ATTEMPTS') {
            PortalHelper.openErrorPopup(
                'Too Many Requests',
                'You have made too many requests recently. This won\'t take long to correct. Please try again soon.'
            );
        }
    },

    // redirect the user
    _redirectLegalError: function(responseCode)
    {
        if (responseCode == 'UNACCEPTED_LEGAL_AGREEMENT') {
            PortalHelper.openErrorPopup(
                'License Agreements',
                'You must accept a new license agreement to continue with our portal. You will be redirected soon.',
                { loading: true }
            );

            setTimeout(function() {
                window.location = PortalConfig.portalUrl + '/legal';
            }, 3000);
        }
    },

    // force the uss user to set up two-factor authentication
    _redirectTwoFactor: function(responseCode, responseMessage)
    {
        if (responseCode == 'USS_TWO_FACTOR_AUTH_REQUIRED'
        || responseCode == 'TWO_FACTOR_AUTH_REQUIRED') {

            PortalHelper.openErrorPopup(
                'Two-Factor Auth Required',
                responseMessage,
                { loading: true }
            );

            setTimeout(function() {
                window.location = PortalConfig.portalUrl + '/users/update-profile?tab-target=user-two-factor';
            }, 3000);
        }
    },

    _hideErrorElement: function()
    {
        $(this.errorElement).addClass('hidden');
    },

    // populate the error element
    _showErrorElement: function(response)
    {
        var html = '';

        // show a list of errors if a validation error, otherwise show the message
        if (response.code == 'VALIDATION_ERROR') {
            for (var i in response.data) {
                for (var x in response.data[i]) {
                    html += response.data[i][x];
                    html += '<br>';
                }
            }
        } else {
            html = response.message;
        }

        $(this.errorElement).html(html);
        $(this.errorElement).removeClass('hidden');
    },

    _hideSuccessElement: function()
    {
        $(this.successElement).addClass('hidden');
    },

    _showSuccessElement: function(response)
    {
        $(this.successElement).html(response.message);
        $(this.successElement).removeClass('hidden');
    }
}
